import { html } from 'lit';
import { Wrench } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-wrench')
export class PdsIconWrench extends PdsIcon {
  @state()
  icon = Wrench;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
